







































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import _ from "lodash";

import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoDialogImages extends Vue {
  @Prop({
    type: String,
    default: "symbol",
  })
  imageListId!: string;
  items: string[] = [];
  url: string | null = null;

  get imageListPath() {
    return `/img/${this.imageListId}s.svg`;
  }

  /*
  get items() {
    return Array.from(new Array(14)).fill("platzhalter");
  } */

  mounted() {
    this.reload();
  }

  async reload() {
    const resp = await fetch(this.imageListPath, { cache: "reload" });

    const test = document.createElement("div") as HTMLDivElement;

    console.log("resp", resp);
    const bodyBlob = await resp.blob();
    const text = await ((bodyBlob as unknown) as {
      text: () => Promise<string>;
    }).text();

    test.innerHTML = text;

    const items = test.querySelectorAll(`g[id^=${this.imageListId}]`);
    if (this.url) {
      URL.revokeObjectURL(this.url);
    }
    this.url = URL.createObjectURL(bodyBlob);

    // mime: image/svg+xml
    //
    this.items = [];
    console.log("SVG", items.length);

    items.forEach((elem) => {
      const id = elem.getAttribute("id");
      if (id) {
        this.items.push(id);
      }
    });
  }

  beforeDestroy() {
    if (this.url) {
      URL.revokeObjectURL(this.url);
    }
  }
}
